import { UPDATE_VIEW_MODE } from '../actions';

export const viewMode = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_VIEW_MODE: {
      return action.viewMode;
    }
    default:
      return state;
  }
};
